import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../request";
import { URL } from "../api";

const RejectSummary = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [summary, setSummary] = useState([]);
  const [loading, setLoading] = useState(true);

  // Extract params from URL
  const queryParams = new URLSearchParams(location.search);
  const customerId = queryParams.get("customer_id");
  const loanId = queryParams.get("loan_id");

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const res = await axiosInstance.get(URL.REJECT_SUMMERY, {
          params: {
            customer_id: customerId,
            loan_id: loanId,
          },
        });
        setSummary(res.data || []);
      } catch (err) {
        console.error("Error fetching reject summary:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchSummary();
  }, [customerId, loanId]);

  // Format date like DB (yyyy-MM-dd HH:mm:ss.SSS)
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    const pad = (n, width = 2) => String(n).padStart(width, "0");
    return (
      `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
      `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.` +
      `${String(d.getMilliseconds()).padStart(3, "0")}`
    );
  };

  return (
    <div className="container mt-4">
      <h3>Reject Summary</h3>
      <button className="btn btn-secondary mb-3" onClick={() => navigate(-1)}>
        ← Back
      </button>

      {loading ? (
        <p>Loading...</p>
      ) : summary.length > 0 ? (
        <div className="table-responsive">
          <table className="table table-bordered table-striped text-nowrap">
            <thead className="table-dark">
              <tr>
                <th>ID</th>
                <th>Customer ID</th>
                <th>Policy Name</th>
                <th>Rule ID</th>
                <th>Rule Name</th>
                <th>Comment</th>
                <th>Action Status</th>
                <th>Updated By</th>
                <th>Create Date</th>
                <th>Update Date</th>
              </tr>
            </thead>
            <tbody>
              {summary.map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item.customerId}</td>
                  <td>{item.policyName}</td>
                  <td>{item.ruleId}</td>
                  <td>{item.ruleName}</td>
                  <td>{item.comment}</td> {/* Full comment shown */}
                  <td>
                    <span
                      className={`badge ${
                        item.actionStatus?.toLowerCase() === "pass"
                          ? "bg-success"
                          : "bg-danger"
                      }`}
                    >
                      {item.actionStatus}
                    </span>
                  </td>
                  <td>{item.updatedBy}</td>
                  <td>{formatDate(item.createDate)}</td>
                  <td>{formatDate(item.updateDate)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="text-muted">No summary found.</p>
      )}
    </div>
  );
};

export default RejectSummary;
